// useLogin.js
import { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../config/api';
import { UserContext } from '../../contexts/UserContext'; // Import UserContext

const useLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(UserContext);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    setError('');

    try {
        const formattedBaseUrl = BASE_URL.replace(/\/+$/, '') + '/';

        const response = await axios.post(`${formattedBaseUrl}auth/login/system`, {
          email,
          password,
        });

        // Support responses shaped as either { user, message } or older structures
        const { user, message } = response.data || {};
        const sessionId = response.data?.sessionId || response.data?.sessionid || null;

        if (user) {
          const loginData = {
            id: user.id || response.data.userId || null,
            email: user.email || email,
            firstname: user.firstname || '',
            lastname: user.lastname || '',
            role: user.email === 'admin3@gmail.com' ? 'admin' : 'user',
            sessionId: response.data.sessionId || response.data.sessionid || null,
          };

          // Save to global context and localStorage
          login(loginData);
          localStorage.setItem('loginData', JSON.stringify(loginData));
          if (sessionId) {
            localStorage.setItem('sessionId', sessionId);
          }

          console.log('✅ Login successful:', message || 'Logged in', loginData);

          // Navigate based on role
          if (loginData.role === 'admin') {
            navigate('/AdminDashboard');
          } else {
            navigate('/Dashboard');
          }
        } else {
          setError(response.data?.error || 'Login failed. Please try again.');
        }
    } catch (error) {
      console.error('Login Error:', error.response?.data || error.message);
      setError(error.response?.data?.error || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    setError,
    loading,
    handleLogin,
  };
};

export default useLogin;
